import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'
import { withTableController } from 'shared/hooks'
import { ServicesContext } from 'services/context'

import { StoreContext } from 'store/context'
import { createColumns } from './columns.description'
import TournamentsOverviewComponent from './component'

// Storage key for persisting filter state (must match the key in filters/container.js)
const MARKETING_FILTER_KEY = 'tournaments_marketing_promotion_filter'

// Helper to get persisted filter value
const getPersistedFilterValue = () => {
  try {
    const saved = localStorage.getItem(MARKETING_FILTER_KEY)
    if (saved === 'true') return true
    if (saved === 'false') return false
  } catch (e) {
    console.warn('Failed to read marketing filter from localStorage:', e)
  }
  return undefined
}

export const TournamentsOverview = combine(
  withTableController({ id: 'tournament-table' }),
  withContext(
    'adminTournamentService',
    ServicesContext,
    ({ adminTournamentService }) => adminTournamentService
  ),
  withContext('appStore', StoreContext),
  withMemo('columns', () => createColumns(), []),
  withCallbacks(
    {
      loadAthletes:
        ({ adminTournamentService }) =>
        async (tableState, _table, query) => {
          const persistedFilter = getPersistedFilterValue()
          const newQuery = query || {}

          const queryParams = {
            tournamentName: newQuery.tournamentName,
            sportType: newQuery.sportTypes,
            page: tableState.page,
            size: tableState.pageSize,
          }

          if (
            newQuery.marketingPromotion === true ||
            newQuery.marketingPromotion === false
          ) {
            queryParams.marketingPromotion = newQuery.marketingPromotion
          } else if (persistedFilter !== undefined) {
            queryParams.marketingPromotion = persistedFilter
          }

          return await adminTournamentService.tournamentsSearch(queryParams)
        },

      onSearch:
        ({ table }) =>
        (query) => {
          table.search(query)
        },
    },
    []
  )
)(TournamentsOverviewComponent)
